import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { SearchBox } from 'fw/forms';
import { DiscountCategoryCombo, SponsorTypeCombo, StatusFilter } from 'areas/shared/controls'
import { SetupSearch } from 'areas/shared/pages/setup';
import * as API from 'modules/app/API';
import DiscountCodeGenerationPopUp from './discountCodeGeneration/DiscountCodeGenerationPopUp';
import * as App from 'modules/app/App';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

class Search extends SetupSearch {

    initialForm() {
		var params = queryString.parse(this.props.location.search);

		var initialDiscountCategoryCode = null;
		var initialDiscountCategoryName = "";
		var initialSponsorTypeCode = null;
		var initialSponsorTypeName = "";
		var initialStatusFilter = true;
		var initialStatusFilterName = "Active codes";

		// The two initial settings below are mutually exclusive because params come from dashboard links
		// (if in the future, params come from other sources, this code has to be modified accordingly)

		// If Discount Category Code param came from Dashboard, do not filter by Status and Sponsor Type // TODO: Review this
		if (params.discountCategoryCode != null){
			initialDiscountCategoryCode = params.discountCategoryCode;
			initialDiscountCategoryName = params.discountCategoryName;
			initialSponsorTypeCode = null;
			initialSponsorTypeName = "";
			initialStatusFilter = null;
			initialStatusFilterName = "All codes";
		}

		// If Sponsor Type Code param came from Dashboard, do not filter by Status and Discount Category // TODO: Review this
		if (params.sponsorTypeCode != null){
			initialDiscountCategoryCode = null;
			initialDiscountCategoryName = "";
			initialSponsorTypeCode = params.sponsorTypeCode;
			initialSponsorTypeName = params.sponsorTypeName;
			initialStatusFilter = null;
			initialStatusFilterName = "All codes";
		}

		// If Active param came from Dashboard, do not filter by Expired
		if (params.active != null){
			initialStatusFilter = params.active;
			initialStatusFilterName = params.active === "true" ? "Active codes" : "Inactive codes";
		}

        return {
            searchText: "",
            statusFilter: initialStatusFilter,
			initialStatusFilterName,
            discountCategoryCode: initialDiscountCategoryCode,
			initialDiscountCategoryName,
			sponsorTypeCode: initialSponsorTypeCode,
			initialSponsorTypeName,
            roleId: null, // TODO: Check the two values below to see if they are needed
            userTypeCode: null,
            addPrivilege: App.hasPrivilege("AdminDiscountCodeSetupGenerate")
        };
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    searchLoader = () => {
        return {
            url: API.Search.url('/suggest'),
            params: {
                type: 'discountCode'
            }
        }
    }

    onGenerateDiscountCodePopUpClose = (success) => {
        this.setState({
            showGenerateDiscountCodePopUp: false
        }, () => { if (success === true) { this.search() } });
    }

    onGenerateDiscountCodeClick = () => {
        this.setState({
            showGenerateDiscountCodePopUp: true
        });
    }

    renderForm() {
        return (
            <Row>
                <Col md={3}>
                    <SearchBox
                        name="searchText"
                        label="searchText"
                        placeholder="Search code..."
                        loader={this.searchLoader}
                        ref={(c) => { this.focusControl = c }} />
                </Col>
				<Col md={2}>
                    <DiscountCategoryCombo clearable name='discountCategoryCode' 
						 label="discountCategory" onChange={this.search} placeholder="Discount Category" />
                </Col>
                <Col md={2}>
                    <SponsorTypeCombo clearable name='sponsorTypeCode' 
						 label="sponsorType" onChange={this.search} placeholder="Sponsor Type" />
                </Col>
                <Col md={2}>
                    <StatusFilter name="statusFilter" label="initialStatusFilterName" onChange={this.search} entity="codes" />
                </Col>
                {this.state.form.addPrivilege ?
                    <Col md={3} style={{paddingRight:"5px"}}>
                        <Button style={{marginTop:"-55px"}} id='btnGenerateDiscountCodePopUp' onClick={this.onGenerateDiscountCodeClick} bsClass="btn btn-success" className="pull-right">
                            Generate Discount Code
                        </Button>
                        {<DiscountCodeGenerationPopUp
                            visible={this.state.showGenerateDiscountCodePopUp}
                            onClose={this.onGenerateDiscountCodePopUpClose}
                        />}
                    </Col>
                :null }
            </Row>
        )
    }
}

export default withRouter(Search);



// WEBPACK FOOTER //
// ./src/areas/admin/discountCodeSetup/Search.js